import { ConeGeometry, CylinderGeometry, Vector3 } from 'three';
/**
 * Helper method to convert ThreeJS geometry to a triangle mesh
 */
export function geometryToMesh(renderer, geometry) {
    const mesh = renderer.createIndexedTriangleMesh();
    const positions = geometry.getAttribute('position');
    for (let i = 0; i < positions.count; i++) {
        const x = positions.getX(i);
        const y = positions.getY(i);
        const z = positions.getZ(i);
        mesh.vertices.push(new Vector3(x, y, z));
    }
    if (geometry.index) {
        for (let i = 0; i < geometry.index.array.length; i++) {
            mesh.indices.push(geometry.index.array[i]);
        }
    }
    mesh.resolve();
    return mesh;
}
/**
 * Calculate the mesh of an arrow
 */
export function generateArrowMesh(renderer, length, radius) {
    const coneGeometry = new ConeGeometry(radius * 5, radius * 10, 10);
    const tailGeometry = new CylinderGeometry(radius, radius, length, 10, 10);
    tailGeometry.rotateX(-Math.PI / 2);
    tailGeometry.translate(0, 0, length / 2);
    coneGeometry.rotateX(Math.PI / 2);
    coneGeometry.translate(0, 0, length);
    const coneMesh = geometryToMesh(renderer, coneGeometry);
    const tailMesh = geometryToMesh(renderer, tailGeometry);
    const arrowMesh = renderer.createIndexedTriangleMesh();
    arrowMesh.vertices = coneMesh.vertices.concat(tailMesh.vertices);
    arrowMesh.indices = coneMesh.indices.concat(tailMesh.indices.map(i => i + coneMesh.vertices.length));
    return arrowMesh;
}
